// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"c9ea8d54","515":"b22868cf","586":"9bd0f98e","723":"0b99ae3a"}[chunkId] + ".chunk.js";
};